/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../ui/Title";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/constants";
import { useAssetsSrc } from "../../hooks/useAssetsSrc";
import { useTranslate } from "../../hooks/useTranslate";

const StyledProviderCard = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const ProviderMedia = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(${({ theme }) => theme.colors.iconStroke.rgba});
  overflow: hidden;
`;

const ProviderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProviderControl = styled.div`
  margin-left: auto;
`;

const ProviderCard = ({ provider, canEdit, canDelete, onDelete }) => {
  const { _t } = useTranslate();
  const navigate = useNavigate();
  const selectedProviderImage = useAssetsSrc(provider.picture_preview);
  const isAnyProvider = provider.id === "any";

  return (
    <StyledProviderCard>
      <ProviderMedia>
        {selectedProviderImage && <ProviderImage src={selectedProviderImage} alt={provider.name} />}
        {!selectedProviderImage && !isAnyProvider && <Icon.User size={Icon.SIZE.SM} color="iconStroke" />}
        {!selectedProviderImage && isAnyProvider && <Icon.Shuffle size={Icon.SIZE.SM} />}
      </ProviderMedia>
      <Title size="h3">{isAnyProvider && !provider.name ? "any_unit" : provider.name}</Title>
      <ProviderControl>
        {canEdit && (
          <Button
            variant="transparent"
            size="icon"
            icon={<Icon.PencilAndPaper color="secondary" />}
            onClick={() => navigate(ROUTES.PROVIDERS)}
            aria-label={_t("Edit provider")}
          />
        )}
        {canDelete && (
          <Button
            variant="transparent"
            size="icon"
            icon={<Icon.Trash color="iconStroke" />}
            onClick={onDelete}
            aria-label={_t("Remove provider")}
          />
        )}
      </ProviderControl>
    </StyledProviderCard>
  );
};

export default ProviderCard;
